/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EMobileNotificationStatus } from "../types/EMobileNotificationStatus.ts";

/**
 * @description 1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled |
 */
export const eMobileNotificationStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
  ) as unknown as ToZod<EMobileNotificationStatus>;
